<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(mapUrl)="data">
                                    <span class="mr-1">
                                        <a
                                            v-if="tableRows[data.index].googleMapLink"
                                            :href="tableRows[data.index].googleMapLink"
                                            target="_blank"
                                            v-b-tooltip.hover="{ boundary: 'window' }"
                                            :title="$t('label.viewX', [$t('label.googleMap')])"
                                        >
                                            <i class="mdi mdi-launch cursor-pointer text-info"></i>
                                        </a>
                                        <i
                                            v-else
                                            class="mdi mdi-launch text-muted"
                                        ></i>
                                    </span>
                                    <span>
                                        <a
                                            v-if="tableRows[data.index].lat && tableRows[data.index].lng"
                                            :href="'https://www.google.com/maps?q=' + tableRows[data.index].lat + ',' + tableRows[data.index].lng"
                                            target="_blank"
                                            v-b-tooltip.hover="{ boundary: 'window' }"
                                            :title="$t('label.viewX', [$t('label.map')])"
                                        >
                                            <i class="mdi mdi-map-marker cursor-pointer text-info"></i>
                                        </a>
                                        <i
                                            v-else
                                            class="mdi mdi-map-marker text-muted"
                                        ></i>
                                    </span>        
                                </template>
                                <template #cell(displayName)="data">
                                    {{ tableRows[data.index].displayName ?? '--' }}
                                </template>
                                <template #cell(city)="data">
                                    {{ tableRows[data.index].city ?? '--' }}
                                </template>
                                <template #cell(postcode)="data">
                                    {{ tableRows[data.index].postcode ?? '--' }}
                                </template>
                                <template #cell(state)="data">
                                    {{ tableRows[data.index].state ? tableRows[data.index].state.name : '--' }}
                                </template>
                                <template #cell(country)="data">
                                    {{ tableRows[data.index].country ? tableRows[data.index].country.name : '--' }}
                                </template>
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="location-form"
            :title="$t(location.uuid ? 'label.updateX' : 'label.createX', [$t('module.location')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <LocationForm
                    :key="locationFormKey"
                    :locationUUID="location.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="locationForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="location-delete"
            :title="location.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ location.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('location-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ location.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { locationMethods } from "@/state/api";
import { LOCATION_MODULE } from "@/state/api/location.state";
import LocationForm from "@/views/pages/admin/location/locationForm";

export default {
    page: {
        title: i18n.t("module.dashboard"),
    },
    components: { Multiselect, LocationForm },
    created() {
        sessionHelper.clearSearch(SESSION.LOCATION_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'name', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'displayName', label: i18n.t("label.displayName"), sortable: true, class: 'text-nowrap' },
                { key: 'city', label: i18n.t("label.city"), sortable: true, class: 'text-nowrap' },
                { key: 'postcode', label: i18n.t("label.postcode"), sortable: true, class: 'text-nowrap' },
                { key: 'state', label: i18n.t("module.state"), sortable: true, class: 'text-nowrap' },
                { key: 'country', label: i18n.t("module.country"), sortable: true, class: 'text-nowrap' },
                { key: 'mapUrl', label: i18n.t("label.mapUrl"), sortable: true, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: false, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            location: {
                uuid: "",
                isActive: false,
            },
            locationFormKey: 0,
        };
    },
    methods: {
        ...locationMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.LOCATION_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.LOCATION_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getLocationList(this.searchCriteria);
        },
        getLocationList(filter) {
            this.getAllLocation({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.LOCATION_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.LOCATION_SEARCH);
            filter.pageNumber = pageNumber;
            this.getLocationList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getLocationList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.location = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('location-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.location.uuid,
                isActive: this.location.isActive == 0 ? 1 : 0,
            };
            this.updateLocationStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('location-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.location = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.locationFormKey += 1;
            this.$nextTick(() => {
                this.$bvModal.show('location-form');
            });
        },
        closeForm() {
            this.location = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('location-form');
        },
    },
    computed: {
        ...mapState(LOCATION_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.location.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.location.list.pagination.total || 0;
        },
    },
}
</script>
